import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { styledWithTheme } from "../../context";
import { BORDER_WIDTH_OUTER, BORDER_COLOR } from "../html/constants";
var defaultProps = {
  maxHeight: 300
};
var TableContainer = styledWithTheme('div')(function (_ref) {
  var theme = _ref.theme,
      maxWidth = _ref.maxWidth,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? defaultProps.maxHeight : _ref$maxHeight,
      hasStickyHeader = _ref.hasStickyHeader,
      isFocusedByTab = _ref.isFocusedByTab;
  var borderColor = theme.selectors.color(BORDER_COLOR);
  return _objectSpread({
    overflowX: 'auto',
    display: 'inline-flex',
    maxWidth: maxWidth
  }, hasStickyHeader && {
    maxHeight: maxHeight,
    border: "".concat(BORDER_WIDTH_OUTER, "px solid ").concat(borderColor),
    ':focus': isFocusedByTab ? {
      boxShadow: "0 0 0pt 2px ".concat(theme.selectors.color('primary80'))
    } : undefined
  });
});
export default TableContainer;